export class PanelAutofillArea {
	public static ALL: number = 1;
	public static INNER: number = 2;
}